export enum PusherEvents {
  newAdminMessage = 'NewAdminMessage',
  newUserMessage = 'NewUserMessage',
  newClientPortalChat = 'NewChatAvailable',
  chatClosed = 'ChatClosed',
}
